<template>
  <div class="animated fadeIn">
    <div v-if="!group.id">
      <p>group not found, or you do not have access to this group in the given Org/Group context.</p>
    </div>
    <div v-if="group.id" class='personPage'>
      <b-row class="mb-3" align-h="between">
        <b-col cols="auto">
          <h4 class="card-title mb-0">{{ group.groupName }}</h4>
          <div class="small text-muted">Added {{ getGroupAddedDate() }}</div>
        </b-col>
        <b-col cols="auto">
          <router-link :to="'/admin/groups/' + group.id + '/edit'">
            <b-button class="mx-0">Edit</b-button>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8">
          <div>
            <b-card no-body>
              <div slot="header">
                <strong>Information</strong>
              </div>
              <b-card-body>
                <div class="pb-4">
                  <small class="mb-0 text-muted text-uppercase font-weight-bold">ID</small>
                  <br>
                  <h4>{{ group.id }}</h4>
                </div>
                <div class="pb-4">
                  <small class="mb-0 text-muted text-uppercase font-weight-bold">Group Name</small>
                  <br>
                  <h4>{{ group.groupName }}</h4>
                </div>
                <div class="pb-4">
                  <small class="mb-0 text-muted text-uppercase font-weight-bold">Is Owning Group</small>
                  <br>
                  <h4>{{ group.isOwningGroup }}</h4>
                </div>                
              </b-card-body>
            </b-card>
          </div>
        </b-col>
        <b-col sm="4">
          <b-row>
            <b-col sm="12">
            <GroupOrganizations 
            :memberOrganizations="group.memberOrgs" 
            :groupId="groupId" 
            :defaultOrg="defaultGroupId"
            :groupName="group.groupName"
            ></GroupOrganizations>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <b-card no-body>
                <b-card-header>
                  <b>Meta</b>
                </b-card-header>

                <b-list-group flush>
                  <b-list-group-item class="small text-muted">
                    <b>Created At: </b> {{ getCreatedAt() }}
                    <div v-if="_.isObject(group.createdBy)">
                      <b> by: </b> {{ _.get(group, 'createdBy.emailAddress', '') }}
                    </div>
                  </b-list-group-item>

                  <b-list-group-item class="small text-muted">
                    <b>Last Updated: </b> {{ getLastUpdateDate() }}
                    <div v-if="_.isObject(group.updatedBy)">
                      <b> by: </b> {{ _.get(group, 'updatedBy.emailAddress', '') }}
                    </div>
                  </b-list-group-item>
                </b-list-group>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GroupOrganizations from '@/components/Admin/GroupOrganizations'
export default {
  name: 'group',
  components: {
    GroupOrganizations
  },
  computed: {
    ...mapGetters({
      group: 'getViewgroup'
    }),
    groupId: function () {
      return parseInt(this.$route.params.id, 10)
    },
    defaultGroupId: function () {
      if (_.isObject(this.group.defaultOrg)) {
        return this.group.defaultOrg.id
      }
      return this.group.defaultOrg
    }
  },
  methods: {
    getCreatedAt () {
      const group = this.group
      if (group.createdAt && group.createdAt.includes('T')) {
        return this.$utils.formatDate(group.createdAt)
      } else if (group.createdAt) {
        return this.$utils.unixToHuman(group.createdAt / 1000)
      }
    },
    getLastUpdateDate () {
      const group = this.group
      if (group.updatedAt && group.updatedAt.includes('T')) {
        return this.$utils.formatDate(group.updatedAt)
      } else if (group.updatedAt) {
        return this.$utils.unixToHuman(group.updatedAt / 1000)
      }
    },
    getGroupAddedDate: function () {
      const group = this.group
      if (group.createdAt && group.createdAt.includes('T')) {
        return this.$utils.formatDate(group.createdAt)
        } else if (group.createdAt) {
        return this.$utils.unixToHuman(group.createdAt / 1000)
      }
      return 'unknown'
    },
    populateRecords: function () {
      this.$store.dispatch('getGroupView', {
        id: this.groupId
      })
    }
  },
  created: function () {
    this.populateRecords()
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/t1/Admin/Group.vue